<template>
    <div
        ref="progressControl"
        class="sbs-video-player-progress-control">
    </div>
</template>

<script>
import videojs from 'video.js';
import { toRaw } from 'vue';

export default {
    name: 'SbsVideoPlayerProgressControl',
    inject: {
        videoPlayerComponent: { default: null },
    },
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
    },
    mounted() {
        const ProgressControl = videojs.getComponent('progressControl');
        const progressControlComponent = new ProgressControl(this.player);
        const progressControl = this.player.controlBar.addChild('ClickableComponent', {
            el: this.$refs.progressControl,
        });

        progressControl.addChild(progressControlComponent);
    },
};
</script>

<style lang="scss">
// stylelint-disable selector-max-compound-selectors

.sbs-video-player-progress-control {
    flex-grow: 1;
    flex-shrink: 0;
}

.vjs-progress-control.vjs-control {
    .vjs-control-bar & {
        width: auto;
    }

    .vjs-progress-holder {
        border-radius: $rounded-5;

        &.vjs-slider {
            background-color: rgba(255, 255, 255, 0.4);
        }

        .vjs-play-progress {
            background-color: var(--video-player-theme);
            border-radius: $rounded-5;

            &::before {
                display: none;
                color: var(--video-player-theme);
            }

            .vjs-time-tooltip {
                display: none;
            }
        }

        .vjs-load-progress {
            background: $gray;
            border-radius: $rounded-5;

            & > div {
                border-radius: $rounded-5;
            }
        }

        .vjs-mouse-display .vjs-time-tooltip {
            top: -50px;
            padding: 8px 12px;
            background-color: $black;
            border-radius: 10px;

            @include typo-additional-book;
        }
    }
}
</style>
